var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#AC6AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 21.4V29.2747C15 31.1327 15 32.0617 15.3646 32.484C15.6809 32.8503 16.1545 33.0415 16.6364 32.9975C17.1921 32.9468 17.8371 32.2782 19.1272 30.9411L20.0563 29.9781C20.4043 29.6174 20.5783 29.4371 20.7832 29.3079C20.9648 29.1935 21.1637 29.109 21.3722 29.0578C21.6073 29 21.8579 29 22.3592 29H26.6C28.8402 29 29.9603 29 30.816 28.564C31.5686 28.1805 32.1805 27.5686 32.564 26.816C33 25.9603 33 24.8402 33 22.6V21.4C33 19.1598 33 18.0397 32.564 17.184C32.1805 16.4314 31.5686 15.8195 30.816 15.436C29.9603 15 28.8402 15 26.6 15H21.4C19.1598 15 18.0397 15 17.184 15.436C16.4314 15.8195 15.8195 16.4314 15.436 17.184C15 18.0397 15 19.1598 15 21.4ZM20 23C20.5523 23 21 22.5523 21 22C21 21.4477 20.5523 21 20 21C19.4477 21 19 21.4477 19 22C19 22.5523 19.4477 23 20 23ZM25 22C25 22.5523 24.5523 23 24 23C23.4477 23 23 22.5523 23 22C23 21.4477 23.4477 21 24 21C24.5523 21 25 21.4477 25 22ZM28 23C28.5523 23 29 22.5523 29 22C29 21.4477 28.5523 21 28 21C27.4477 21 27 21.4477 27 22C27 22.5523 27.4477 23 28 23Z",
    fill: "#0E0C15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.a41ef3353584079dbd3b5f4f493fb9c7.svg";
export { ForwardRef as ReactComponent };